import { create } from "zustand";

type TabItem<T> = {
  value: T;
  label: string;
  disabled?: boolean;
};

type UseTabsFactoryState<T extends string> = {
  selectedTab: T;
  setSelectedTab: (tab: T) => void;
};

export const useTabsFactory = <T extends string>(tabs: TabItem<T>[]) =>
  create<UseTabsFactoryState<T>>((set) => ({
    selectedTab: tabs[0]?.value || ("" as T),
    setSelectedTab: (tab) => {
      if (tabs.some((item) => item.value === tab)) {
        set({ selectedTab: tab });
      }
    },
  }));
